import React from "react"
import { Spin as CustomSpin, SpinProps } from "antd"

const Spin: React.FC<SpinProps> = ({ children, ...rest }) => (
  <CustomSpin {...rest}>{children}</CustomSpin>
)

export default Spin
